/** @jsxImportSource theme-ui */
import theme from "config/theme";
import Link from "next/link";

interface FooterLinkProps {
  url: string;
  text: string;
}
const FooterLink = ({ url, text }: FooterLinkProps) => {
  return (
    <Link href={url}>
      <a sx={theme.links.footer}>{text}</a>
    </Link>
  );
};

export default FooterLink;
